import { createReducer } from '/@/store/utils';

const initial = {};

export default createReducer(initial, {});
